import type { LngLatLike, Map as MapLibreMap } from 'maplibre-gl';

/** Camera moves take this long for a hop within the view, ms… */
const MIN_DURATION = 600;
/** …growing by this much per zoom level the trip spans… */
const DURATION_PER_LEVEL = 200;
/** …up to this for a trip across the world. */
const MAX_DURATION = 1500;

/**
 * Duration of a camera move to `center` at `zoom`, ms: short hops are quick, long trips take longer.
 * The trip is measured in zoom levels: screens to travel (log2, as flyTo zooms out by about that much
 * to get there) plus the zoom change.
 */
export function flightDuration(map: MapLibreMap, center: LngLatLike, zoom = map.getZoom()) {
  const { clientWidth, clientHeight } = map.getContainer();
  const from = map.project(map.getCenter());
  const to = map.project(center);
  const screens = Math.hypot(to.x - from.x, to.y - from.y) / Math.max(1, clientWidth, clientHeight);
  const levels = Math.log2(1 + screens) + Math.abs(zoom - map.getZoom());
  return Math.min(MAX_DURATION, MIN_DURATION + levels * DURATION_PER_LEVEL);
}
